import React from 'react';
import OpinionItem from './OpinionItem';
import OpinionDraftItem from './OpinionDraftItem';

const OpinionItemIndex = props => {
  const { opinion, isDraft, withComment = true } = props;
  if (isDraft) {
    return <OpinionDraftItem opinion={opinion} />;
  }
  return <OpinionItem opinion={opinion} withComment={withComment} />;
};

export default OpinionItemIndex;
